export default __webpack_public_path__ + "images/b6c32c490cb4373e72368fe64cb9cd0a.svg";